import React, { Component } from 'react';

class AddProjectButton extends Component {
  render() {
    return (
      <div style={{ display: 'flex', padding: '10px' }}>
        <button className="button" onClick={this.props.newProject}>
          New Project
        </button>
      </div>
    );
  }
}

export default AddProjectButton;



// WEBPACK FOOTER //
// ./src/components/AddProjectButton/AddProjectButton.js